import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../../../../../../core/decorators/auto-unsubscribe';
import { CustomerDeleteService } from '../../servicios/customer-delete.service';

@Component({
  selector: 'app-delete-customer-modal',
  templateUrl: './delete-customer-modal.component.html',
  styleUrls: ['./delete-customer-modal.component.scss']
})

@AutoUnsubscribe()
export class DeleteCustomerModalComponent implements OnInit {
  @Output() modalClose = new EventEmitter<any>();

  @Input() title: string;
  @Input() message: string;
  @Input() textButtonOk: string;
  @Input() textButtonCancel: string;

  @Input() aspa: boolean;
  @Input() isButtonOk: boolean;
  @Input() isButtonCancel: boolean;

  @Input() dataCustomer: any;
  deactivarSubscription: Subscription;
  error: string;
  code: string;
  constructor(
    private _customerDeleteService: CustomerDeleteService,
    private translateService: TranslateService,
    private toastr: ToastrService) { }

  ngOnInit() { }


  closeModal(conDatos) {

    if (conDatos) {
      const parametros_In = {
        deleteId: this.dataCustomer.CustomerId
      };

      this.deactivarSubscription = this._customerDeleteService.post<any>(JSON.stringify(parametros_In))
        .subscribe(data => {
          const auxdata = data.Response;
          if (auxdata) {
            if (auxdata.Data) {
              this.translateService.get('genericos.toastr.successfulDelete').subscribe(text => {
                this.toastr.success(text);
                this.modalClose.emit(auxdata.Data);
              });
            } else {
              this.translateService.get('genericos.toastr.imposibleborrar').subscribe(res => {
                this.toastr.error(res);
              });
              this.modalClose.emit('cerrar');
            }

          } else {
            this.error = data.Warning.Content;
            this.code = data.Warning.Title;
            this.translateService.get('genericos.toastr.imposibleborrar').subscribe(res => {
              this.toastr.error(res);
            });
            this.modalClose.emit('cerrar');

          }
        });

    } else {

      this.modalClose.emit('cerrar');

    }

  }
}


